import setConsent from './setConsent'

export { setConsent }

const consentService = {
  setConsent
}

export default consentService
